// eslint-disable-next-line import/prefer-default-export
export const hiddenSearchInputClearIconSelectPopup = () => ({
  adornmentButton: {
    display: "none",
  },
});
